import { Link } from 'react-router-dom';
import { categories } from '@/mocks/homeData';
import { useScrollReveal } from '@/hooks/useScrollReveal';

export default function CategoryGrid() {
  const { ref, animated } = useScrollReveal();

  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="container-custom">
        <div className={`text-center mb-10 md:mb-14 ${animated ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} style={{ transition: 'all 0.6s ease-out' }} ref={ref}>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-foreground-900">
            探索分类
          </h2>
          <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-xl mx-auto">
            四大内容板块，全方位满足你的少女心~
          </p>
        </div>

        <div className={`grid grid-cols-1 sm:grid-cols-2 gap-6 stagger-children ${animated ? 'animated' : ''}`}>
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="stagger-item group relative bg-background-50 rounded-lg overflow-hidden cursor-pointer h-64 md:h-72 transition-all duration-300 hover:scale-[1.01]"
            >
              <div className="absolute inset-0">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/20 to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-6">
                <div className="flex items-center gap-3 mb-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-full bg-primary-500 text-white">
                    <i className={`${cat.icon} text-lg`}></i>
                  </div>
                  <h3 className="text-xl font-heading font-bold text-white">{cat.name}</h3>
                </div>
                <p className="text-sm text-white/70 line-clamp-1">{cat.description}</p>
                <span className="inline-block mt-3 text-xs text-white/60 bg-white/15 px-3 py-1 rounded-full">
                  {cat.articleCount} 篇内容
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}